import AddPartner from './partner-add-container';

export default AddPartner;
